import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import { Link } from 'react-router-dom'
import Getintouch from '../layouts/Getintouch'

const Aboutlogics = () => {
    const services = [
        {
            title: 'Laravel',
            subtitle: 'Service Container',
            description: 'Build powerful, custom websites with the strength and flexibility of Laravel.',
            image: process.env.PUBLIC_URL + '/images/laravel-logo.png',
            alt: 'Laravel',
            color: 'cyan',
        },
        {
            title: 'Shopify',
            subtitle: 'Marketplace',
            description: 'Shopify solutions to launch or grow your store, customized to fit your brand and goals.',
            image: process.env.PUBLIC_URL + '/images/shopify-removebg-preview.png',
            alt: 'App Dev',
            color: 'orange',
        },
        {
            title: 'webflow',
            subtitle: 'Services',
            description: 'Visually stunning websites powered by Webflow and launching a brand-new site or need a redesign',
            image: process.env.PUBLIC_URL + '/images/webflow.png',
            alt: 'Graphic Design',
            color: 'green',
        },
        {
            title: 'WordPress',
            subtitle: 'Customization',
            description: 'Custom WordPress themes tailored to your brand — no generic templates.',
            image: process.env.PUBLIC_URL + '/images/wordpress-removebg-preview.png',
            alt: 'UI UX',
            color: 'pink',
        },
        {
            title: 'Android',
            subtitle: 'App Services',
            description: 'Seamless Android app development aligned with your business vision.',
            image: process.env.PUBLIC_URL +'/images/android-removebg-preview.png',
            alt: 'SEO',
            color: 'purple',
        },
    ];
    return (
        <div>
            <Header />
            <Link class="back-button" to={"/Service"}><i class="fa-solid fa-arrow-left"></i>Back</Link>
            <section>
                <div className="area-text">
                    <h2 className="text-h2">
                        We build what the world <br />
                        clicks on
                    </h2>
                    <p className="text-p">
                        We build more than just websites—we create powerful, scalable <br />
                        digital solutions that grow with your business
                    </p>
                    <div className="Outline">
                        <h1 className="outlined-text">Repeated</h1>
                    </div>
                    <p className="outline-p">until it's perfect</p>
                </div>
            </section>

            <section className="services">
                {services.map((service, index) => (
                    <div className="service-box" key={index}>
                        <div className={`icon-circle ${service.color}`}>
                            <img src={service.image} alt={service.alt} />
                        </div>
                        <h3 className="service-box-h3">{service.title}</h3>
                        <h4 className="service-box-h4">{service.subtitle}</h4>
                        <p className="service-box-p">{service.description}</p>
                        <a href="#" className="more-link">Work showcase</a>
                    </div>
                ))}
            </section>

            <Getintouch />
            <Footer />
        </div>
    )
}

export default Aboutlogics